import { render } from "./ParticleComponent.vue?vue&type=template&id=6027084e&scoped=true"
import script from "./ParticleComponent.vue?vue&type=script&lang=js"
export * from "./ParticleComponent.vue?vue&type=script&lang=js"

import "./ParticleComponent.vue?vue&type=style&index=0&id=6027084e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6027084e"]])

export default __exports__